<template>
  <b-field
    :label="label"
    :message="hasUserInactif ? $t(msgError) : ''"
    :type="hasUserInactif ? 'is-warning' : ''"
    :class="{ 'obligatoire': obligatoire }">
    <qd-taginput
      v-model="userSelected"
      @typing="(txt) => search = txt"
      :data="filteredUsers"
      :disabled="disabled"
      :placeholder="placeholder"
      :field="field"
      :class="{
        'tagInputDisabled' : disabled,
        'tagInputRemoveIconRight': hasUserInactif,
      }"
      type="is-primary"
      ref="userTags"
      expanded
      autocomplete
      open-on-focus>
      <template #selected="{ tags }">
        <b-tag
          v-for="(tag, index) in tags" :key="index"
          @close="$refs.userTags.removeTag(index, $event)"
          :type="tag.actif ? 'is-primary' : 'is-warning'"
          closable>
          {{getValue(tag)}}
        </b-tag>
      </template>
    </qd-taginput>
  </b-field>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import getValueByPath from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'user-selected',
  props: {
    value: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    obligatoire: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    critere: {
      type: Function,
      default: () => true,
    },
    field: {
      type: String,
      default: 'decorator.nomPrenom',
    },
    placeholder: {
      type: String,
      default: '',
    },
    msgError: {
      type: String,
      default: 'utilisateur.warning.utilisateursArchives',
    },
  },
  data() {
    return {
      search: null,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    users() {
      const items = cloneDeep(this.parametre(PARAMETRES_KEYS.utilisateur))
        .sort((a, b) => this.getValue(a).localeCompare(this.getValue(b)));
      return items
        .filter(u => u.actif || this.userSelected.map(v => v.id).includes(u.id))
        .filter(u => this.critere(u));
    },
    userSelected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    filteredUsers() {
      return this.users.filter((u) => {
        return !this.alreadySelected(u) && this.searchMatch(u);
      });
    },
    hasUserInactif() {
      return this.userSelected.some(v => !v.actif);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    getValue(obj) {
      return getValueByPath(obj, this.field);
    },
    alreadySelected(item) {
      return this.userSelected.map(u => u.id).includes(item.id);
    },
    searchMatch(item) {
      return this.search != null
        ? this.getValue(item).toString().toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        : true;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
